import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.css';

export default function CompetitiveIndex({ value, size }) {
  const getSizeCssClass = () => {
    if (size === 'sm') {
      return styles.small;
    }
    if (size === 'md') {
      return styles.medium;
    }
    return styles.large;
  };

  const getRangeCssClass = () => {
    if (value > 0) {
      if (value > 90) {
        return styles.positiveIndex;
      }
      if (value < 50) {
        return styles.negativeIndex;
      }
      return styles.neutralIndex;
    }

    return null;
  };

  return (
    <div className={`${styles.competitiveIndexCircle} ${getSizeCssClass()} ${getRangeCssClass()}`}>
      {value > 0 ? value : (<span className={styles.unavailable}>N/A</span>)}
    </div>
  );
}

CompetitiveIndex.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

CompetitiveIndex.defaultProps = {
  value: 'N/A',
  size: 'lg',
};
